import { executeRequest, Request } from '@jfs/network'
import { dateFormatter, DateFormatTypes } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = ({ data }: any, mid: any) => {
  const resData = {
    mid,
    keyValue: data?.applications[0]?.appClientDtoList[0].secretCode,
    clientId: data?.applications[0]?.appClientDtoList[0].clientId,
    creationDate: dateFormatter(data?.applications[0]?.appClientDtoList[0].createdAt, DateFormatTypes.DATE_AM_PM),
  }

  return resData
}

const getUserSettings = (tokens: any, requestBody: any) => {
  const config = sitConfig(tokens)

  const request: Request<{}> = {
    config: config,
    apiPath: APIEndPoints.getApiCredentials,
    method: 'POST',
    body: requestBody,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data, requestBody.externalReferenceId)
  })
}

export { getUserSettings }
